module.exports = __webpack_public_path__ + "static/media/settings-toggle-button.30f16f41.svg";